import { createPortal } from 'react-dom';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import {
	AuthError,
	AuthField,
	AuthInput,
	AuthLabel,
	AuthSuccess,
	ResetBack,
	ResetCard,
	ResetClose,
	ResetForm,
	ResetHeader,
	ResetOverlay,
	ResetSubmit,
} from './authModal.styles';

const ResetPasswordModal = ({
	email,
	resetMessage,
	isLoading,
	isSuccess,
	onEmailChange,
	onSubmit,
	onClose,
	onConfirmSuccess,
}) => {
	const translations = useLanguageData('login');
	const authModal = useLanguageData('authModal');

	return createPortal(
		<ResetOverlay onClick={isSuccess ? undefined : onClose}>
			<ResetCard onClick={(event) => event.stopPropagation()}>
				<ResetClose type="button" onClick={onClose} aria-label={authModal.close}>
					×
				</ResetClose>
				<ResetHeader>
					<h3>
						{isSuccess
							? translations.resetSuccessTitle || 'Check your email'
							: translations.resetModalTitle || 'Reset Your Password'}
					</h3>
					<p>
						{isSuccess
							? translations.resetSuccessHint
							: translations.resetModalHint}
					</p>
				</ResetHeader>

				{isSuccess ? (
					<>
						<AuthSuccess>{translations.resetSuccessMessage}</AuthSuccess>
						<ResetSubmit type="button" onClick={onConfirmSuccess}>
							{translations.resetBackToLogin || 'Back to log in'}
						</ResetSubmit>
					</>
				) : (
					<ResetForm onSubmit={onSubmit}>
						{resetMessage && <AuthError>{resetMessage}</AuthError>}
						<AuthField>
							<AuthLabel $visible htmlFor="auth-reset-email">
								{translations.emailLabel || 'Email Address'}
							</AuthLabel>
							<AuthInput
								id="auth-reset-email"
								type="email"
								placeholder={translations.emailPlaceholder || 'enter your email'}
								value={email}
								onChange={(event) => onEmailChange(event.target.value)}
								required
								disabled={isLoading}
								autoFocus
							/>
						</AuthField>
						<ResetSubmit type="submit" disabled={isLoading}>
							{isLoading
								? translations.resetSending || 'Sending...'
								: translations.sendResetLinkButton || 'Send Reset Link'}
						</ResetSubmit>
						<ResetBack type="button" onClick={onClose}>
							{translations.resetBackToLogin || 'Back to log in'}
						</ResetBack>
					</ResetForm>
				)}
			</ResetCard>
		</ResetOverlay>,
		document.body,
	);
};

export default ResetPasswordModal;
